import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Tag, Button } from 'antd';
import { txt } from 'libs/i18n';
import { clsx } from 'clsx';
import styles from './style.module.less';
const maxTagLength = 40;
const tagIds = [
    'inAnyField',
    'projectname',
    'transcription',
    'speakers',
    'notes',
];
const FulltextSearchTags = ({ searchParams, onTagRemoved, onResetFulltextSearch, }) => {
    return (_jsxs(_Fragment, { children: [tagIds.map((tagId) => {
                const tagText = `${txt(tagId)}: ${searchParams[tagId]}`;
                const tagContent = tagText.length <= maxTagLength ? tagText : `${tagText.slice(0, maxTagLength)}...`;
                return searchParams[tagId] === '' ? null : (_jsxs(Tag, { onClose: () => onTagRemoved(tagId), closable: true, className: clsx(styles.searchTag), children: [_jsx("span", { className: styles.searchTagWide, children: tagText }), _jsx("span", { className: styles.searchTagNarrow, children: tagContent })] }, tagId));
            }), _jsx(Button, { className: styles.resetButton, onClick: onResetFulltextSearch, children: _jsx("span", { children: txt('clearSearch') }) })] }));
};
export default FulltextSearchTags;
